import { render, staticRenderFns } from "./AlertsWidget.vue?vue&type=template&id=cbbe3dae&"
import script from "./AlertsWidget.vue?vue&type=script&lang=js&"
export * from "./AlertsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports